import React, { useEffect, useRef } from "react";
import { useState } from "react";
import style from "../../../../../assets/styles/testCreationStyle.module.css";
import {
  Add_Section_Test,
  Edit_Section_Test,
  Get_All_Identifier,
  Get_Replace_question,
  changeAdd_test_screen,
  changeEdit_test_screen,
} from "../../../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import BrowsingQuestionEdit from "./BrowsingQuestionEdit";
import {
  GET_QUESTION_BANK,
  GET_REVIEW_DATA,
} from "../../../../../action/apiPath";
import { CallWithAuth } from "../../../../../action/apiActions";
import moment from "moment";
import QuillEditor from "../../../../atoms/QuillEditor";
// _________which one to show my or all _________

const SectionsEdit = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    dispatch(Get_All_Identifier("", ""));
  }, []);
  const { identifierList, testCreationId, replacedQuestion, getBasicSettingData, testDetails } = useSelector((state) => state.GetAllData);


  const [body, setBody] = useState({
    groups: [
      {
        group_name: "",
        randomize_sections: false,
        has_unattempted_negative_marking: false,
        group_instructions: "",
        sections: [
          {
            section_name: "",
            identifier: null,
            no_of_questions: 0,
            randomize_questions_within_section: false,
            correct_answer_marks: null,
            incorrect_answer_marks: null,
            questions: [],
          }
        ],
      }
    ],
  });


  //__________ Group -> add , remove , drag & drop __________
  // const [groups, setGroups] = useState([0]);
  const [groupsbutton, setgroupsButton] = useState(0);

  const [section, setsection] = useState([0, 1]);
  const [sectionbutton, setsectionButton] = useState(0);


  // const closegroups = () => {
  // }

  // const closegroups = () => {
  //   // setGroups(groups.filter((items, i) => items !== groupsbutton))
  //   setGroups((previousArr) => previousArr.slice(0, -1));
  //   // setsection((previousArr) => previousArr.slice(0, -1));
  //   if (groups[groups.length - 1] == groupsbutton) {
  //     setgroupsButton(groups.length - 2);
  //   }
  // };


  // useEffect(() => {
  //   // Function to update body state when groups change
  //   const updateBodyState = () => {
  //     const newBodyState = {
  //       groups: groups.map((group) => {
  //         // Find the corresponding group in the body state
  //         const existingGroup = body.groups.find((g) => g.group_name === group);
  //         return (
  //           existingGroup || {
  //             group_name: "",
  //             randomize_sections: false,
  //             has_unattempted_negative_marking: false,
  //             group_instructions: "",
  //             sections: [
  //               {
  //                 section_name: "",
  //                 identifier: null,
  //                 no_of_questions: 0,
  //                 randomize_questions_within_section: false,
  //                 correct_answer_marks: null,
  //                 incorrect_answer_marks: null,
  //                 questions: [],
  //               }
  //             ],
  //           }
  //         );
  //       }),
  //     };
  //     setBody(newBodyState);
  //   };

  //   // Call the function to update body state when groups change
  //   updateBodyState();
  // }, [groups]); // useEffect will run whenever groups state changes

  // //__________ Section -> add , remove , drag & drop __________


  const closesection = () => { }

  // const closesection = () => {
  //   // setsection(section.filter((items, i) => items !== sectionbutton))
  //   setsection((previousArr) => previousArr.slice(0, -1));
  //   if (section[section.length - 1] == sectionbutton) {
  //     setsectionButton(section.length - 2);
  //   }
  // };



  useEffect(() => {
    if (body.groups[groupsbutton].sections[sectionbutton] == undefined) {
      setsectionButton(body.groups[groupsbutton].sections.length - 1);
    }
  }, [groupsbutton]);



  const [groups, setGroups] = useState(
    [
      { id: 0, sections: [0] }
    ]
  );

  // add group 
  const addGroup = () => {
    setGroups([
      ...groups,
      { id: groups.length, sections: [0] },
    ]);

    setBody(prevBody => ({
      ...prevBody,
      groups: [
        ...prevBody.groups,
        {
          group_name: "",
          randomize_sections: false,
          has_unattempted_negative_marking: false,
          group_instructions: "",
          sections: [
            {
              section_name: "",
              identifier: null,
              no_of_questions: 0,
              randomize_questions_within_section: false,
              correct_answer_marks: body?.groups[groupsbutton]?.sections[sectionbutton]?.correct_answer_marks,
              incorrect_answer_marks: body?.groups[groupsbutton]?.sections[sectionbutton]?.incorrect_answer_marks,
              questions: [],
            }
          ],
        }
      ]
    }));

    SetSelectIds([])

  };

  // close group 
  const closegroups = () => {
    // setGroups(groups.filter((items, i) => items !== groupsbutton))
    setGroups((previousArr) => previousArr.slice(0, -1));
    // setsection((previousArr) => previousArr.slice(0, -1));
    if (groups.length - 1 == groupsbutton) {
      setgroupsButton(groups.length - 2);
    }
  };

  // effect of add group or delete 
  // useEffect(() => {
  //   alert('s')
  //   // Function to update body state when groups change
  //   const updateBodyState = () => {
  //     const newBodyState = {
  //       groups: groups.map((group,index) => {
  //         // Find the corresponding group in the body state
  //         const existingGroup = body.groups.find((g) => g.group_name === index);
  //         return (
  //           existingGroup || {
  //             group_name: "",
  //             randomize_sections: false,
  //             has_unattempted_negative_marking: false,
  //             group_instructions: "",
  //             sections: [
  //               {
  //                 section_name: "",
  //                 identifier: null,
  //                 no_of_questions: 0,
  //                 randomize_questions_within_section: false,
  //                 correct_answer_marks: null,
  //                 incorrect_answer_marks: null,
  //                 questions: [],
  //               }
  //             ],
  //           }
  //         );
  //       }),
  //     };
  //     setBody(newBodyState);
  //   };

  //   // Call the function to update body state when groups change
  //   updateBodyState();
  // }, [groups]); // useEffect will run whenever groups state changes


  const addSection = (groupId) => {
    setGroups(groups.map(group => {
      if (group.id === groupId) {
        const newSectionId = group.sections.length;
        return {
          ...group,
          sections: [...group.sections, newSectionId]
        };
      }
      return group;
    }));

    setBody(prevBody => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId) {
            const newSection = {
              section_name: "",
              identifier: null,
              no_of_questions: 0,
              randomize_questions_within_section: false,
              correct_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.correct_answer_marks,
              incorrect_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.incorrect_answer_marks,
              questions: [],
            };
            return {
              ...group,
              sections: [...group.sections, newSection]
            };
          }
          return group;
        })
      };
    });

  };

  const deleteSection = (groupId) => {
    setGroups(prevGroups => {
      return prevGroups.map(group => {
        if (group.id === groupId && group.sections.length > 1) {
          return {
            ...group,
            sections: group.sections.slice(0, -1)
          };
        }
        return group;
      });
    });

    setBody(prevBody => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId && group.sections.length > 1) {
            return {
              ...group,
              sections: group.sections.slice(0, -1)
            };
          }
          return group;
        })
      };
    });

    // {console.log("final",groups[groupsbutton].sections.length-2)}
    setsectionButton(groups[groupsbutton].sections.length - 2)
  };


  useEffect(() => {
    SetSelectIds([])
  }, [sectionbutton])

  //__________ questionpanelty -> add , remove , drag & drop __________
  // const [QuestionPanelty, setQuestionPanelty] = useState([0, 1]);
  // const [QuestionPaneltybutton, setQuestionPaneltyButton] = useState(0);

  // const closeQuestionPanelty = () => {
  //   // setQuestionPanelty(QuestionPanelty.filter((items, i) => items !== QuestionPaneltybutton))
  //   setQuestionPanelty((previousArr) => previousArr.slice(0, -1));
  //   if (QuestionPanelty[QuestionPanelty.length - 1] == QuestionPaneltybutton) {
  //     setQuestionPaneltyButton(QuestionPanelty.length - 2);
  //   }
  // };

  // useEffect(() => {
  //   // Function to add or remove sections based on the difference between new and previous section state
  //   const updatePaneltyRange = (QuestionPanelty) => {
  //     const currentPaneltyLength =
  //       body.groups[groupsbutton].sections[sectionbutton]
  //         .question_penalty_ranges.length;
  //     const diff = QuestionPanelty.length - currentPaneltyLength;

  //     // console.log(
  //       "QuestionPanelty ",
  //       QuestionPanelty,
  //       QuestionPaneltybutton,
  //       diff,
  //       section,
  //       sectionbutton
  //     );

  //     if (diff > 0) {
  //       // Add sections
  //       setBody((prevState) => ({
  //         ...prevState,
  //         groups: [
  //           {
  //             ...prevState.groups[groupsbutton],
  //             sections: [
  //               {
  //                 ...prevState.groups[groupsbutton].sections[sectionbutton],
  //                 question_penalty_ranges: [
  //                   ...prevState.groups[groupsbutton].sections[sectionbutton]
  //                     .question_penalty_ranges,
  //                   ...Array(diff).fill({
  //                     from: null,
  //                     to: null,
  //                     penalty_marks: null,
  //                   }),
  //                 ],
  //               },
  //               ...prevState.groups[groupsbutton].sections.slice(1),
  //               // ...Array(diff).fill({
  //               //   section_name: "",
  //               //   identifier: null,
  //               //   no_of_questions: 0,
  //               //   randomize_questions_within_section: false,
  //               //   correct_answer_marks: null,
  //               //   incorrect_answer_marks: null,
  //               //   unattempted_marks: null,
  //               //   question_penalty_ranges: [
  //               //     {
  //               //       from: null,
  //               //       to: null,
  //               //       penalty_marks: null
  //               //     },
  //               //     {
  //               //       from: null,
  //               //       to: null,
  //               //       penalty_marks: null
  //               //     }
  //               //   ],
  //               //   questions: [
  //               //     {
  //               //       id: null,
  //               //       correct_answer_marks: null,
  //               //       incorrect_answer_marks: null,
  //               //       unattempted_penalty: null
  //               //     },
  //               //     {
  //               //       id: null,
  //               //       correct_answer_marks: null,
  //               //       incorrect_answer_marks: null,
  //               //       unattempted_penalty: null
  //               //     },
  //               //     {
  //               //       id: null,
  //               //       correct_answer_marks: null,
  //               //       incorrect_answer_marks: null,
  //               //       unattempted_penalty: null
  //               //     }
  //               //   ]
  //               // })
  //             ],
  //           },
  //           ...prevState.groups.slice(1),
  //         ],
  //       }));
  //     } else if (diff < 0) {
  //       // Remove sections
  //       setBody((prevState) => ({
  //         ...prevState,
  //         groups: [
  //           {
  //             ...prevState.groups[groupsbutton],
  //             sections: [
  //               {
  //                 ...prevState.groups[groupsbutton].sections[sectionbutton],
  //                 question_penalty_ranges: prevState.groups[
  //                   groupsbutton
  //                 ].sections[sectionbutton].question_penalty_ranges.slice(
  //                   0,
  //                   QuestionPanelty.length
  //                 ),
  //               },
  //               ...prevState.groups[groupsbutton].sections.slice(1),
  //             ],
  //           },
  //           ...prevState.groups.slice(1),
  //         ],
  //       }));
  //     }
  //   };

  //   updatePaneltyRange(QuestionPanelty);
  // }, [QuestionPanelty]);

  const ChangeGroupName = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, index) =>
        index === groupsbutton ? { ...group, group_name: e.target.value } : group
      )
    }));
  };

  const ChangeRandomize_Sections = (e) => {

    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, index) =>
        index === groupsbutton ? { ...group, randomize_sections: e } : group
      )
    }));

  };

  const ChangeNegativePenalityMarking = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, index) =>
        index === groupsbutton ? { ...group, has_unattempted_negative_marking: e } : group
      )
    }));
  };

  const ChangeGroupInstruction = (content) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, index) =>
        index === groupsbutton ? { ...group, group_instructions: btoa(unescape(encodeURIComponent(content))) } : group
      )
    }));
  };

  const ChangeSectionName = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, gIndex) =>
        gIndex === groupsbutton
          ? {
            ...group,
            sections: group.sections.map((section, sIndex) =>
              sIndex === sectionbutton
                ? { ...section, section_name: e.target.value }
                : section
            )
          }
          : group
      )
    }));

  };

  const ChangeSectionIdentifier = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, gIndex) =>
        gIndex === groupsbutton
          ? {
            ...group,
            sections: group.sections.map((section, sIndex) =>
              sIndex === sectionbutton
                ? { ...section, identifier: Number(e.target.value) }
                : section
            )
          }
          : group
      )
    }));
  };

  const ChangeSectionQuestionTotal = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, gIndex) =>
        gIndex === groupsbutton
          ? {
            ...group,
            sections: group.sections.map((section, sIndex) =>
              sIndex === sectionbutton
                ? { ...section, no_of_questions: Number(e.target.value) }
                : section
            )
          }
          : group
      )
    }));

  };

  const ChangeSectionRandomQuestion = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, gIndex) =>
        gIndex === groupsbutton
          ? {
            ...group,
            sections: group.sections.map((section, sIndex) =>
              sIndex === sectionbutton
                ? { ...section, randomize_questions_within_section: Boolean(e) }
                : section
            )
          }
          : group
      )
    }));

  };


  const [disableMarking, setDisableMarking] = useState(true)

  const ChangeSectionCorrectMarks = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, gIndex) =>
        gIndex === groupsbutton
          ? {
            ...group,
            sections: group.sections.map((section, sIndex) =>
              sIndex === sectionbutton
                ? { ...section, correct_answer_marks: Number(e) }
                : section
            )
          }
          : group
      )
    }));
    ChangeMarkingLogic({
      "correct_answer_marks": Number(e),
      "incorrect_answer_marks": body.groups[groupsbutton].sections[
        sectionbutton
      ].incorrect_answer_marks
    })

  };

  const ChangeSectionInCorrectMarks = (e) => {
    setBody(prevState => ({
      ...prevState,
      groups: prevState.groups.map((group, gIndex) =>
        gIndex === groupsbutton
          ? {
            ...group,
            sections: group.sections.map((section, sIndex) =>
              sIndex === sectionbutton
                ? { ...section, incorrect_answer_marks: Number(e) }
                : section
            )
          }
          : group
      )
    }));

    ChangeMarkingLogic({
      "correct_answer_marks": body.groups[groupsbutton].sections[
        sectionbutton
      ].correct_answer_marks,
      "incorrect_answer_marks": Number(e)
    })

  };

  useEffect(() => {
    if (getBasicSettingData != null) {
      ChangeSectionCorrectMarks(body.groups[groupsbutton].sections[sectionbutton]?.correct_answer_marks)
      ChangeSectionInCorrectMarks(body.groups[groupsbutton].sections[sectionbutton]?.incorrect_answer_marks)
    }

  }, [getBasicSettingData])

  // const ChangeSectionUnAttemptedMarks = (e) => {
  //   const updatedBody = { ...body };
  //   updatedBody.groups[groupsbutton].sections[sectionbutton].unattempted_marks =
  //     Number(e.target.value);
  //   setBody(updatedBody);
  // };

  // const ChangeSectionQuestionPaneltyFrom = (e, i) => {
  //   const updatedBody = { ...body };
  //   updatedBody.groups[groupsbutton].sections[
  //     sectionbutton
  //   ].question_penalty_ranges[i].from = Number(e.target.value);
  //   setBody(updatedBody);
  // };

  // const ChangeSectionQuestionPaneltyTo = (e, i) => {
  //   const updatedBody = { ...body };
  //   updatedBody.groups[groupsbutton].sections[
  //     sectionbutton
  //   ].question_penalty_ranges[i].to = Number(e.target.value);
  //   setBody(updatedBody);
  // };

  // const ChangeSectionQuestionPaneltyMarks = (e, i) => {
  //   const updatedBody = { ...body };
  //   updatedBody.groups[groupsbutton].sections[
  //     sectionbutton
  //   ].question_penalty_ranges[i].penalty_marks = Number(e.target.value);
  //   setBody(updatedBody);
  // };

  // console.log("body", body);

  const [modal, setModal] = useState(false);

  const AddQuestionFromBank = () => {
    if (body.groups[groupsbutton].sections[sectionbutton].no_of_questions > 0) {
      SetremoveId([]);
      setModal(true);
    } else {
      alert("please choose No. Of Questions First");
    }
  };

  const [selectIds, SetSelectIds] = useState([]);

  // useEffect(() => {
  //   if (selectIds.length === 0) return; // No need to proceed if selectIds is empty
  //   if (
  //     selectIds.length >
  //     body.groups[groupsbutton].sections[sectionbutton].questions.length
  //   ) {

  //     const updatedGroups = {
  //       ...body,
  //       groups: body.groups.map((group, gIndex) => {
  //         if (gIndex !== groupsbutton) return group;

  //         return {
  //           ...group,
  //           sections: group.sections.map((section, sIndex) => {
  //             if (sIndex !== sectionbutton) return section;

  //             return {
  //               ...section,
  //               questions: [
  //                 ...section.questions,
  //                 ...selectIds.map((id) => ({
  //                   id,
  //                   correct_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.correct_answer_marks,
  //                   incorrect_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.incorrect_answer_marks,
  //                   // unattempted_penalty: 0,
  //                 })),
  //               ],
  //             };
  //           }),
  //         };
  //       }),
  //     };

  //     setBody(updatedGroups);
  //     // console.log("updatedGroups", updatedGroups);
  //   } else {
  //     // Clean up: Remove questions associated with the removed IDs
  //     const removedIds = body.groups[groupsbutton].sections[
  //       sectionbutton
  //     ].questions
  //       .filter((question) => !selectIds.includes(question.id))
  //       .map((question) => question.id);

  //     if (removedIds.length >= 0) {
  //       const groupIndex = groupsbutton;
  //       const sectionIndex = sectionbutton;

  //       setBody(prevBody => {
  //         const updatedGroups = prevBody.groups.map((group, gIndex) => {
  //           if (gIndex !== groupIndex) return group; // Return unchanged group if it's not the target group

  //           const updatedSections = group.sections.map((section, sIndex) => {
  //             if (sIndex !== sectionIndex) return section; // Return unchanged section if it's not the target section

  //             // Filter out the questions to be removed
  //             const filteredQuestions = section.questions.filter(
  //               question => !removedIds.includes(question.id)
  //             );

  //             // Return updated section with filtered questions
  //             return {
  //               ...section,
  //               questions: filteredQuestions
  //             };
  //           });

  //           // Return updated group with updated sections
  //           return {
  //             ...group,
  //             sections: updatedSections
  //           };
  //         });

  //         // Return updated body with updated groups
  //         return { ...prevBody, groups: updatedGroups };
  //       });

  //     }
  //   }
  // }, [selectIds]);

  const AddToTestPaper = () => {
    if (selectIds.length === 0) return; // No need to proceed if selectIds is empty

    const group = body.groups[groupsbutton];
    const section = group.sections[sectionbutton];
    const existingQuestions = section.questions;

    if (selectIds.length > existingQuestions.length) {
      // Extract existing question IDs
      const existingQuestionIds = new Set(existingQuestions.map((q) => q.id));

      // Filter out existing IDs and create new question objects
      const newQuestions = selectIds
        .filter((id) => !existingQuestionIds.has(id))
        .map((id) => ({
          id,
          correct_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.correct_answer_marks,
          incorrect_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.incorrect_answer_marks
        }));

      // Create a new questions array by concatenating existing questions with new questions
      const updatedQuestions = [...existingQuestions, ...newQuestions];

      // Create a new updatedGroups object with the new questions array
      const updatedGroups = {
        ...body,
        groups: body.groups.map((g, gIdx) =>
          gIdx === groupsbutton
            ? {
              ...g,
              sections: g.sections.map((s, sIdx) =>
                sIdx === sectionbutton
                  ? { ...s, questions: updatedQuestions }
                  : s
              )
            }
            : g
        )
      };

      setBody(updatedGroups);
    } else {
      // Clean up: Remove questions associated with the removed IDs
      const removedIds = existingQuestions
        .filter((question) => !selectIds.includes(question.id))
        .map((question) => question.id);

      if (removedIds.length >= 0) {
        const filteredQuestions = existingQuestions.filter(
          (question) => !removedIds.includes(question.id)
        );

        // Create a new updatedGroups object with the filtered questions array
        const updatedGroups = {
          ...body,
          groups: body.groups.map((g, gIdx) =>
            gIdx === groupsbutton
              ? {
                ...g,
                sections: g.sections.map((s, sIdx) =>
                  sIdx === sectionbutton
                    ? { ...s, questions: filteredQuestions }
                    : s
                )
              }
              : g
          )
        };

        setBody(updatedGroups);
      }
    }

    setModal(false);
  };

  const [removeId, SetremoveId] = useState([]);

  // console.log("removeId", removeId, selectIds);

  const DeleteIdFromList = () => {
    // const filteredSelectIds = body.groups[groupsbutton].sections[sectionbutton]?.questions.filter((id) => !removeId.includes(id.id));
    // // SetSelectIds(filteredSelectIds);

    // { console.log("filteredSelectId", filteredSelectIds) }
    // const updatedGroups = { ...body };
    // updatedGroups.groups[groupsbutton].sections[sectionbutton].questions =
    //   filteredSelectIds;
    // console.log("DeleteIdFromList", updatedGroups);
    // setBody(updatedGroups);

    setBody(prevBody => {
      const updatedGroups = prevBody.groups.map((group, groupIndex) => {
        if (groupIndex !== groupsbutton) return group;

        return {
          ...group,
          sections: group.sections.map((section, sectionIndex) => {
            if (sectionIndex !== sectionbutton) return section;

            return {
              ...section,
              questions: section.questions.filter((id) => !removeId.includes(id.id))
            };
          })
        };
      });

      return { ...prevBody, groups: updatedGroups };
    });

    SetremoveId([])
  };

  const RemoveIds = (items, check) => {
    if (check) {
      SetremoveId((prevState) => [...prevState, items.question_id]);
    } else {
      const filteredArr = removeId.filter(
        (value) => value !== items.question_id
      );
      SetremoveId(filteredArr);
    }
  };

  // question bank get
  // Get the current year
  const currentYear = new Date().getFullYear();
  // _________ PRIMARY TAG STATE INITIALIZATION _________
  const [questionId, setquestionId] = useState(0);
  const [multiselectedSubjectTag, setmultiSelectedSubjectTag] = useState([]);
  const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([]);
  const [multiselectedCategoryTag, setmultiSelectedCategoryTag] = useState([]);
  const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([]);
  const [sort, setSort] = useState("");
  // Initialize state for the selected year
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedYearExclude, setSelectedYearExclude] = useState(currentYear);
  // _________ YEAR USED-> STATE INITIALIZATION _________

  // const [currentSort, setCurrentSort] = useState("")

  // ________ PAGINATION ________

  const [totalCount, setTotalCount] = useState(0);
  const [last, setLast] = useState(5);
  const [limit, setLimit] = useState(5);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // _________question bank id which is top dropdown _________
  const [questionBankId, setQuestionBankId] = useState(4);

  useEffect(() => {
    // alert(totalCount)
    if (totalCount < 5) {
      setLast(totalCount);
    } else {
      setLast(5);
    }
  }, [totalCount]);

  const handleSort = (e) => {
    if (sort === "") {
      setSort(e);
    } else if (sort === e) {
      setSort(`-${e}`);
    } else {
      setSort(e);
    }
  };

  // _________ALL question created listing data _________
  const [questionResults, setquestionResults] = useState([]);

  const QuestionListing = async () => {
    // console.log("questionlistingData", body?.groups[groupsbutton]?.sections?.[sectionbutton]?.questions?.map((items,i)=>items?.id).join(","));


    const url = GET_REVIEW_DATA + "?question_ids=" + body?.groups[groupsbutton]?.sections?.[sectionbutton]?.questions?.map((items, i) => items?.id).join(",");

    // console.log("url", url);
    const questionlistingData = await CallWithAuth("GET", url);
    if (questionlistingData.status && questionlistingData.res.status === 200) {
      setquestionResults(questionlistingData.res.data);
      setTotalCount(questionlistingData.res.data.length);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    if(body?.groups[groupsbutton]?.sections?.[sectionbutton]?.questions.length > 0){
      QuestionListing();
    }
  }, [questionBankId, questionId, offset, sort,groupsbutton, sectionbutton, body?.groups[groupsbutton]?.sections?.[sectionbutton]?.questions]);

  /*****Function to open edit / delete modal */
  const [showModal, setShowModal] = useState(false);

  // // console.log("Showing", sortProductType);
  const handleClick = (index) => {
    setShowModal((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  // __________ outside clickable close modal _______________

  const modalRef = useRef();
  const [replaceId, setReplaceId] = useState(null);

  const GetReplace = (items) => {
    setReplaceId(items.question_id);
    const sectionIDs = body.groups[groupsbutton].sections[sectionbutton]?.questions?.map(target => target.id)

    dispatch(Get_Replace_question(items.question_id, sectionIDs));
  };

  useEffect(() => {
    if (replacedQuestion != null) {
      const id = replacedQuestion.question_id;

      const newArray = body.groups[groupsbutton].sections[sectionbutton]?.questions.map((num) =>
        num.id === replaceId ? {
          "id": replacedQuestion.question_id,
          "correct_answer_marks": body.groups[groupsbutton].sections[sectionbutton]?.correct_answer_marks,
          "incorrect_answer_marks": body.groups[groupsbutton].sections[sectionbutton]?.incorrect_answer_marks
        } : num
      );


      const updatedGroups = { ...body };
      updatedGroups.groups[groupsbutton].sections[sectionbutton].questions = newArray;
      setBody(updatedGroups);
      // SetSelectIds(newArray);
      setShowModal(false);
      // // console.log("replaceId",replacedQuestion.question_id,replaceId, selectIds)
    }
  }, [replacedQuestion]);

  const GetDelete = (items) => {
    // const filteredSelectIds = body.groups[groupsbutton].sections[sectionbutton]?.questions.filter((id) => items.question_id != id.id);
    // const updatedGroups = { ...body };
    // updatedGroups.groups[groupsbutton].sections[sectionbutton].questions = filteredSelectIds;
    // setBody(updatedGroups);

    setBody(prevBody => {
      const updatedGroups = prevBody.groups.map((group, groupIndex) => {
        if (groupIndex !== groupsbutton) return group;

        return {
          ...group,
          sections: group.sections.map((section, sectionIndex) => {
            if (sectionIndex !== sectionbutton) return section;

            return {
              ...section,
              questions: section.questions.filter((question) => question.id !== items.question_id)
            };
          })
        };
      });

      return { ...prevBody, groups: updatedGroups };
    });

    setShowModal(false);
  };
  const [markingLogicStatus, setMarkingLogicStatus] = useState(false);

  const [markingLogic, setMarkingLogic] = useState([]);


  const AddNewScore = () => {
    setMarkingLogic((prevState) => [
      ...prevState,
      {
        correct_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.correct_answer_marks,
        incorrect_answer_marks: body.groups[groupsbutton].sections[sectionbutton]?.incorrect_answer_marks
      },
    ]);
  };

  // Function to handle change event
  const handleCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      correct_answer_marks: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };

  const handleInCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      incorrect_answer_marks: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };

  // const handleUnattemptedChange = (event, i) => {
  //   const newValue = parseFloat(event.target.value); // Assuming input value is a number
  //   const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
  //   updatedMarkingLogic[i] = {
  //     ...updatedMarkingLogic[i],
  //     // unattempted_penalty: newValue,
  //   }; // Update correct_answer_marks at index 1
  //   setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  // };

  const SelectedMarkingLogic = (items) => {
    const groupIndex = groupsbutton;
    const sectionIndex = sectionbutton;

    setBody(prevBody => {
      const updatedGroups = prevBody.groups.map((group, gIndex) => {
        if (gIndex !== groupIndex) return group; // Return unchanged group if it's not the target group

        const updatedSections = group.sections.map((section, sIndex) => {
          if (sIndex !== sectionIndex) return section; // Return unchanged section if it's not the target section

          const updatedQuestions = section.questions.map(question => {
            if (removeId.includes(question.id)) {
              return {
                ...question,
                correct_answer_marks: items.correct_answer_marks,
                incorrect_answer_marks: items.incorrect_answer_marks,
                // unattempted_penalty: items.unattempted_penalty,
              };
            }
            return question; // Return unchanged question if it doesn't match the removeId
          });
          return {
            ...section,
            questions: updatedQuestions,
          };
        });

        return {
          ...group,
          sections: updatedSections,
        };
      });

      return { ...prevBody, groups: updatedGroups };
    });
    SetremoveId([]);
    setMarkingLogicStatus(!markingLogicStatus);
    // console.log("SelectedMarkingLogic", items, body, selectIds, removeId);
  };

  // console.log("markingLogic", markingLogic);

  const ChangeMarkingLogic = (items) => {
    const groupIndex = groupsbutton;
    const sectionIndex = sectionbutton;

    setBody(prevBody => {
      const updatedGroups = prevBody.groups.map((group, gIndex) => {
        if (gIndex !== groupIndex) return group; // Return unchanged group if it's not the target group

        const updatedSections = group.sections.map((section, sIndex) => {
          if (sIndex !== sectionIndex) return section; // Return unchanged section if it's not the target section

          const updatedQuestions = section.questions.map(question => {
            // if (removeId.includes(question.id)) {
            return {
              ...question,
              correct_answer_marks: items.correct_answer_marks,
              incorrect_answer_marks: items.incorrect_answer_marks,
              // unattempted_penalty: items.unattempted_penalty,
            };
            // }
            // return question; // Return unchanged question if it doesn't match the removeId
          });
          return {
            ...section,
            questions: updatedQuestions,
          };
        });

        return {
          ...group,
          sections: updatedSections,
        };
      });

      return { ...prevBody, groups: updatedGroups };
    });
    SetremoveId([]);
    // setMarkingLogicStatus(!markingLogicStatus);
    // console.log("SelectedMarkingLogic", items, body, selectIds, removeId);
  };

  const OpenMarkingLogic = () => {
    if (Array.isArray(removeId) && removeId.length > 0) {
      setMarkingLogicStatus(!markingLogicStatus);
    } else {
      alert("please choose question first");
    }
  };


  const decodeBase64 = (base64String) => {
    return atob(base64String);
  };


  useEffect(() => {

    setBody({
      "groups": testDetails?.group_details
    })


    const initialGroups = testDetails?.group_details.map((group, index) => ({
      id: index,
      sections: group.sections.map(section => section.order)
    }));

    setGroups(initialGroups);

    setMarkingLogic((prevstate) => [...prevstate, {
      correct_answer_marks: testDetails?.group_details[groupsbutton]?.sections[sectionbutton]?.correct_answer_marks,
      incorrect_answer_marks: testDetails?.group_details[groupsbutton]?.sections[sectionbutton]?.incorrect_answer_marks
    }])


    // SetSelectIds(testDetails.groups[0].sections[0].questions);

  }, [testDetails])


  useEffect(() => {
    if (body.groups.length == 0) {
      addGroup()
    }
  }, [body])



  function b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }



  // console.log("body-->",body?.groups[groupsbutton]?.sections?.[sectionbutton]?.questions?.map((items,i)=>items?.id).join(","))
  return (
    <div className={style.masterTestCreation}>
      <div className={style.testCreationArea}>
        <div className={style.containGroup}>
          <div className={style.bisectAdd}>
            {groups?.map((items, i) => (
              <button
                draggable="true"
                className={
                  i === groupsbutton
                    ? ` ${style.multiquestionbutton} ${style.draggable}`
                    : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                }
                onClick={() => setgroupsButton(i)}
              >
                {items === groupsbutton ? (
                  <svg
                    width="10"
                    height="14"
                    viewBox="0 0 10 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    width="10"
                    height="14"
                    viewBox="0 0 10 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                      fill="#272727"
                    />
                  </svg>
                )}{" "}
                &nbsp; Group {i + 1}
              </button>
            ))}
          </div>
          <div className={`${style.icon_text} ${style.group_icon}`}>
            <div
              style={{
                border: "1px solid #3ebb5d",
                height: "20px",
                width: "20px",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() =>
                ChangeRandomize_Sections(
                  !body?.groups[groupsbutton]?.randomize_sections
                )

              }
            >

              {body?.groups[groupsbutton]?.randomize_sections ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    fill="url(#paint0_linear_1449_53208)"
                  />
                  <path
                    d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1449_53208"
                      x1="22"
                      y1="2"
                      x2="7.89816"
                      y2="18.4928"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#9BF763" />
                      <stop offset="1" stop-color="#25AB5B" />
                    </linearGradient>
                  </defs>
                </svg>
              ) : (
                ""
              )}
            </div>

            <p className={style.info}>Randomize Sections Within Group</p>
          </div>
        </div>

        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className={style.threshold}
        >
          <div
            className={style.setter}
            // onClick={() => setGroups((current) => [...current, groups.length])}
            onClick={() => addGroup()}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="#00ABFB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.5 12H16.5"
                stroke="#00ABFB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 16.5V7.5"
                stroke="#00ABFB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h5>Add Group</h5>
          </div>
          {/* group add button  */}
          {groups.length <= 1 ? (
            ""
          ) : (
            <button
              className={style.removeGroupButton}
              onClick={() => closegroups()}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                  stroke="#272727"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                  stroke="#272727"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                  stroke="#272727"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Remove Group
            </button>
          )}
        </div>

        {body.groups
          .filter((item, key) => key == groupsbutton)
          .map((items, i) => (
            <div className={style.section_form}>
              <h5 className={style.testMarklabel}>Group {groupsbutton + 1} Details</h5>
              {/* group details -body  */}
              <div className={style.groupName}>
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  Group Name
                  <b className={style.red_mendantory}>*</b>
                </span>

                <input
                  type="textArea"
                  placeholder="Group Name"
                  className={style.groupDrop}
                  onChange={(e) => ChangeGroupName(e)}
                  value={items.group_name}
                />

                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  Group Instructions
                </span>

                {/* <textarea
                    type="textArea"
                    placeholder="Type here"
                    className={style.typeArea}
                    onChange={(e) => ChangeGroupInstruction(e)}
                    value={items.group_instructions}
                  /> */}
                {/* <Editor
                  key={i}
                  apiKey='43r1aznok44zxafnhlerjdhremu6cizk6ropi635y4we48qz'
                  init={{
                    plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount linkchecker markdown',
                    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                  }}
                  value={decodeBase64(items?.group_instructions)}
                  onEditorChange={(content) => ChangeGroupInstruction(content)}
                /> */}

                <div style={{ height: "auto", flexGrow: "1" }}>
                  <QuillEditor
                    defaultValue={decodeBase64(items?.group_instructions)}
                    onChange={(content) => ChangeGroupInstruction(content)} />
                </div>



                {getBasicSettingData?.rendering_template === 5 && <div className={`${style.icon_text} ${style.group_icon}`}>
                  <div
                    style={{
                      border: "1px solid #3ebb5d",
                      height: "20px",
                      width: "20px",
                      borderRadius: "6px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() =>
                      ChangeNegativePenalityMarking(
                        !body.groups[groupsbutton].has_unattempted_negative_marking
                      )
                    }
                  >
                    {body.groups[groupsbutton].has_unattempted_negative_marking ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          fill="url(#paint0_linear_1449_53208)"
                        />
                        <path
                          d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1449_53208"
                            x1="22"
                            y1="2"
                            x2="7.89816"
                            y2="18.4928"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#9BF763" />
                            <stop offset="1" stop-color="#25AB5B" />
                          </linearGradient>
                        </defs>
                      </svg>
                    ) : (
                      ""
                    )}
                  </div>

                  <p className={style.info}>Has Unattempted Negative Marking</p>
                </div>}


              </div>

              <h5 className={style.testMarklabel}>Sections</h5>
              {/* section buttons  */}
              <div className={style.containGroup}>
                {items.sections?.map((items, i) => (
                  <button
                    draggable="true"
                    key={i}
                    className={
                      i === sectionbutton
                        ? ` ${style.multiquestionbutton} ${style.draggable}`
                        : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                    }
                    onClick={() => setsectionButton(i)}
                  >
                    {i === sectionbutton ? (
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                          fill="white"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                          fill="#272727"
                        />
                      </svg>
                    )}{" "}
                    &nbsp; Section {i + 1}
                  </button>
                ))}
              </div>
              {/* section add button  */}
              {/* {console.log("checking",section)} */}
              <div
                style={{ display: "flex", justifyContent: "space-between" }}
                className={style.threshold}
              >
                <div
                  className={style.setter}
                  // onClick={() =>
                  //   setsection((current) => [...current, section.length])
                  // }
                  onClick={() => addSection(groups[groupsbutton].id)}
                >
                  {" "}
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                      stroke="#00ABFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 12H16.5"
                      stroke="#00ABFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 16.5V7.5"
                      stroke="#00ABFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <h5>Add Section</h5>{" "}
                </div>

                {section.length <= 1 ? (
                  ""
                ) : (
                  <button
                    className={` ${style.removeGroupButton} ${style.section_remove}`}
                    onClick={() => deleteSection(groups[groupsbutton].id)}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                        stroke="#272727"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                        stroke="#272727"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                        stroke="#272727"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Remove Section
                  </button>
                )}
              </div>

              {items.sections
                .filter((item, key) => key == sectionbutton)
                .map((sectionItem, sectionKey) => (
                  <div className={style.pageTwoSection} key={sectionKey}>
                    <div className={style.bound}>
                      <div className={style.templateDrop} key={sectionKey}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>Section Name </span>
                            <b className={style.red_mendantory}>*</b>
                            <input
                              name="question"
                              id="question"
                              className={` ${style.score_drop_filter} ${style.verbalBox}`}
                              placeholder=""
                              onChange={(e) => ChangeSectionName(e)}
                              value={sectionItem.section_name}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Test type */}
                      <div className={style.templateDrop} key={sectionKey}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>Section Identifier </span>
                            <b className={style.red_mendantory}>*</b>
                            <select
                              name="question"
                              id="question"
                              value={sectionItem.identifier == null ? "Select Section Identifier" : sectionItem.identifier}
                              onChange={(e) => ChangeSectionIdentifier(e)}
                              className={` ${style.template_drop_filter} ${style.varc}`}
                            >
                              <option value={null}>Select Section Identifier</option>
                              {identifierList?.map((items, i) => (
                                <option value={items.id}>{items.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className={style.templateDrop} key={sectionKey}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>No. of Questions</span>
                            <b className={style.red_mendantory}>*</b>
                            <input
                              name="question"
                              id="question"
                              className={style.score_drop_filter}
                              placeholder=""
                              onChange={(e) => ChangeSectionQuestionTotal(e)}
                              value={sectionItem.no_of_questions}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <p
                      style={{ fontWeight: "500" }}
                      className={style.marketLogic}
                    >
                      Randomize Questions Within Section
                      <b className={style.red_mendantory}>*</b>{" "}
                    </p>
                    <div className={style.levels}>
                      <input
                        type="radio"
                        checked={sectionItem.randomize_questions_within_section}
                        onClick={() => ChangeSectionRandomQuestion(true)}
                      />
                      <label htmlFor="test level">Yes</label>
                      <input
                        style={{ marginLeft: "20px" }}
                        checked={
                          !sectionItem.randomize_questions_within_section
                        }
                        onClick={() => ChangeSectionRandomQuestion(false)}
                        type="radio"
                      />
                      <label htmlFor="section level">No</label>
                    </div>
                    <hr className={style.sectionsHR} />
                    <h3 className={style.testMarklabel}>
                      Group Marking Details
                    </h3>
                    <p className={style.info}>
                      Editing marking logic will only apply to selected section.
                      All questions will follow same marking logic unless new
                      marking logics are created
                    </p>
                    <div className={style.bound}>

                      <div className={style.templateDrop} key={sectionKey}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>Correct Answer Marks </span>
                            <b className={style.red_mendantory}>*</b>
                            <input
                              type="number"
                              name="question"
                              disabled={disableMarking}
                              id="question"
                              className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                              placeholder=""
                              onChange={(e) => ChangeSectionCorrectMarks(e.target.value)}
                              value={sectionItem.correct_answer_marks == null ? "" : sectionItem.correct_answer_marks}
                            />
                          </div>
                        </div>
                      </div>

                      <div className={style.templateDrop}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>Incorrect Answer Marks </span>
                            <b className={style.red_mendantory}>*</b>
                            <input
                              type="number"
                              disabled={disableMarking}
                              name="question"
                              id="question"
                              className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                              placeholder=""
                              onChange={(e) => ChangeSectionInCorrectMarks(e.target.value)}
                              value={sectionItem.incorrect_answer_marks == null ? "" : sectionItem.incorrect_answer_marks}
                            />
                          </div>
                        </div>
                      </div>

                      {disableMarking ? <div
                        onClick={() => setDisableMarking(false)}
                        style={{ cursor: "pointer" }}
                        className={style.threshold}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 22H21"
                            stroke="#00ABFB"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z"
                            stroke="#00ABFB"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.8906 5.04883C12.3206 7.80883 14.5606 9.91883 17.3406 10.1988"
                            stroke="#00ABFB"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <h5>Edit</h5>
                      </div> :
                        <div
                          onClick={() => setDisableMarking(true)}
                          style={{ cursor: "pointer" }}
                          className={style.threshold}
                        >
                          {/* <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 22H21"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.8906 5.04883C12.3206 7.80883 14.5606 9.91883 17.3406 10.1988"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg> */}

                          <h5>Done</h5>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                              fill="url(#paint0_linear_1449_53208)"
                            />
                            <path
                              d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_1449_53208"
                                x1="22"
                                y1="2"
                                x2="7.89816"
                                y2="18.4928"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#00ABFB" />
                                <stop offset="1" stop-color="#00ABFB" />
                              </linearGradient>
                            </defs>
                          </svg>

                        </div>}

                      {/* Test type */}
                      {/* {getBasicSettingData.marking_scheme == 0 ? <>
                          <div className={style.templateDrop}>
                            <div className={style.templateDrop_item}>
                              <div className={style.templateGroup}>
                                <span>Incorrect Answer Marks </span>
                                <b className={style.red_mendantory}>*</b>
                                <input
                                  type="number"
                                  name="question"
                                  id="question"
                                  className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                  placeholder=""
                                  onChange={(e) => ChangeSectionInCorrectMarks(e)}
                                  value={sectionItem.incorrect_answer_marks == null ? "" : sectionItem.incorrect_answer_marks}
                                />
                              </div>
                            </div>
                          </div>
  
                          <div className={style.templateDrop}>
                            <div className={style.templateDrop_item}>
                              <div className={style.templateGroup}>
                                <span>Unattempted Marks </span>
                                <b className={style.red_mendantory}>*</b>
                                <input
                                  type="number"
                                  name="question"
                                  id="question"
                                  className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                  placeholder=""
                                  onChange={(e) => ChangeSectionUnAttemptedMarks(e)}
                                  value={sectionItem.unattempted_marks == null ? "" : sectionItem.unattempted_marks}
                                />
                              </div>
                            </div>
                          </div> </> : ""} */}



                      {/* <div
                          style={{ cursor: "pointer" }}
                          className={style.threshold}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 22H21"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.8906 5.04883C12.3206 7.80883 14.5606 9.91883 17.3406 10.1988"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
  
                          <h5>Edit</h5>
                        </div> */}
                    </div>

                    {/* {getBasicSettingData.marking_scheme == 0 && getBasicSettingData.additional_penalty_unattempted_questions && getBasicSettingData.marking_logic_level == 1 ? <>
                        <p
                          style={{ fontWeight: "500" }}
                          className={style.marketLogic}
                        >
                          Unattempted questions Penalty Ranges
                        </p>
  
                        {sectionItem?.question_penalty_ranges?.map((items, i) => (
                          <div className={style.penalty_range} key={i}>
                            <span className={style.marketLogic}>From</span>
                            <input
                              name="question"
                              id="question"
                              key={i}
                              className={` ${style.penalty_drop_filter} ${style.fullbg}`}
                              placeholder="Input no.of questions"
                              onChange={(e) =>
                                ChangeSectionQuestionPaneltyFrom(e, i)
                              }
                              value={items.from == null ? "" : items.from}
                            />
  
                            <span className={style.marketLogic}>To</span>
                            <input
                              name="question"
                              id="question"
                              key={i}
                              className={style.penalty_drop_filter}
                              placeholder="Input no.of questions"
                              onChange={(e) => ChangeSectionQuestionPaneltyTo(e, i)}
                              value={items.to == null ? "" : items.to}
                            />
                            <div className={style.setPenalty} key={i}>
                              <span className={`${style.marketLogic} ${style.pp}`}>
                                Penalty Marks
                                <b className={style.red_mendantory}>*</b>
                              </span>
  
                              <input
                                name="question"
                                id="question"
                                className={style.drop_marks}
                                placeholder=""
                                onChange={(e) =>
                                  ChangeSectionQuestionPaneltyMarks(e, i)
                                }
                                value={
                                  items.penalty_marks == null
                                    ? ""
                                    : items.penalty_marks
                                }
                              />
                            </div>
  
                            {i !== 0 && (
                              <button
                                className={style.penaltyDelete}
                                onClick={() => closeQuestionPanelty()}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                    stroke="#272727"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                    stroke="#272727"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                    stroke="#272727"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        ))}
  
                        <div
                          style={{ cursor: "pointer" }}
                          className={style.threshold}
                          onClick={() =>
                            setQuestionPanelty((current) => [
                              ...current,
                              QuestionPanelty.length,
                            ])
                          }
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.5 12H16.5"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12 16.5V7.5"
                              stroke="#00ABFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <h5>Add New Threshold</h5>
                        </div>
  
                      </> : ""} */}

                    <hr className={style.sectionsHR} />

                    {/* question list  */}
                    <div className={style.questionBank}>
                      <div className={style.headerBank}>
                        <h4 style={{ fontWeight: "500" }}>Question List</h4>

                        <button
                          className={style.addNewQuestionBt}
                          onClick={() => AddQuestionFromBank()}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.16797 10H18.168"
                              stroke="#00ABFB"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.168 18V2"
                              stroke="#00ABFB"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span> Add questions from question bank</span>
                        </button>
                      </div>
                      <div className={style.handleAttempt}>
                        <span> {sectionItem.questions?.length}</span>
                        <span style={{ color: "lightgray" }}>
                          /{sectionItem.no_of_questions}
                        </span>
                        <span> selected</span>
                      </div>
                      <div
                        style={{ marginTop: "30px" }}
                        className={style.sub_head_content_table}
                      >
                        <table>
                          <thead>
                            <tr>
                              <th
                                className={` ${style.very_first} ${style.pointer}`}
                              >
                                S.No
                              </th>

                              <th
                                className={` ${style.very_first} ${style.pointer}`}
                              >
                                Question ID and Tags
                              </th>
                              <th
                                className={` ${style.first} ${style.pointer}`}
                              >
                                <span>General Tags</span>
                                {/* <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z" fill="#00ABFB" />
                 <path d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z" fill="#00ABFB" />
                 <path d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z" fill="#00ABFB" />
                 <path d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z" fill="#00ABFB" />
               </svg> */}
                              </th>
                              <th
                                className={` ${style.second} ${style.pointer}`}
                              >
                                {" "}
                                <span>Author</span>
                                <svg
                                  width="19"
                                  height="12"
                                  viewBox="0 0 19 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                                    fill="#00ABFB"
                                  />
                                </svg>
                              </th>
                              <th
                                className={` ${style.third} ${style.pointer}`}
                              >
                                <span>Created On</span>
                                <svg
                                  width="19"
                                  height="12"
                                  viewBox="0 0 19 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                                    fill="#00ABFB"
                                  />
                                </svg>
                              </th>
                              <th
                                className={` ${style.fourth} ${style.pointer}`}
                              >
                                <span>LOD</span>
                                <svg
                                  width="19"
                                  height="12"
                                  viewBox="0 0 19 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                                    fill="#00ABFB"
                                  />
                                  <path
                                    d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                                    fill="#00ABFB"
                                  />
                                </svg>
                              </th>

                              <th
                                className={` ${style.fifth} ${style.pointer}`}
                              >
                                <span>Select to make changes</span>
                                <input type="checkbox" />
                              </th>
                              <th></th>
                            </tr>
                          </thead>

                          {/* ALL AND MY QUESTION according to ternary operator */}
                          <tbody>

                            {isLoading ? (
                              <div className={style.mixed}>
                                <div className={style.spinner}></div>
                                <p className={style.loading_message}>Loading...</p>
                              </div>
                            ) : (
                              questionResults
                                ?.filter((item) =>
                                  sectionItem?.questions?.map(target => target.id).includes(item.question_id)
                                )
                                .map((items, i) => (
                                  <tr
                                    className={style.table_body_content}
                                    key={i}
                                  >
                                    <td className={style.srNo}>
                                      <div className={style.srContent}>
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                            fill="#272727"
                                          />
                                        </svg>
                                        {i + 1}
                                      </div>
                                    </td>
                                    <td>
                                      <div className={style.question_id_tag}>
                                        <div className={style.id}>
                                          {items.question_id}
                                        </div>
                                        <div className={style.tag}>
                                          {/* {console.log(items)} */}
                                          <p>{items.question_short_identifier}</p>
                                          <span>{items.primary_tag.slug}</span>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className={style.general_tag}>
                                        {items.free_tags.map((item, i) => (
                                          <button
                                            className={style.general_button}
                                          >
                                            {item.name}
                                          </button>
                                        ))}
                                      </div>
                                    </td>
                                    <td>
                                      <div className={style.author_tag}>
                                        Author by {items.created_by}
                                      </div>
                                    </td>
                                    <td>
                                      <div className={style.created_date}>
                                        {" "}
                                        {moment(items.created_at).format(
                                          "Do MMM YYYY"
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div className={style.lod}>
                                        {items.difficulty}
                                      </div>
                                    </td>

                                    <td>
                                      <div
                                        className={style.changeCheckbox}
                                        key={removeId.length}
                                      >
                                        <div className={style.changesEvent}>
                                          <input
                                            type="text"
                                            style={{
                                              display: "inline",
                                              width: "20%",
                                              border: "none",
                                              background: "transparent",
                                            }}
                                            value={
                                              sectionItem?.questions[i]
                                                ?.correct_answer_marks
                                            }
                                          />
                                          <input
                                            type="text"
                                            style={{
                                              display: "inline",
                                              width: "20%",
                                              border: "none",
                                              background: "transparent",
                                            }}
                                            value={
                                              sectionItem?.questions[i]
                                                ?.incorrect_answer_marks
                                            }
                                          />
                                          {/* <input
                                            type="text"
                                            style={{
                                              display: "inline",
                                              width: "10%",
                                              border: "none",
                                              background: "transparent",
                                            }}
                                            value={
                                              sectionItem?.questions[i]
                                                ?.unattempted_penalty
                                            }
                                          /> */}
                                        </div>{" "}
                                        <input
                                          type="checkbox"
                                          checked={removeId?.includes(
                                            items.question_id
                                          )}
                                          onClick={(e) =>
                                            RemoveIds(items, e.target.checked)
                                          }
                                        />
                                      </div>
                                    </td>

                                    <td>
                                      <div
                                        className={` ${style.action} ${style.pointer} ${style.actions_question}`}
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          onClick={() => handleClick(i)}
                                        >
                                          <path
                                            d="M12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18C10 17.4696 10.2107 16.9609 10.5858 16.5858C10.9609 16.2107 11.4696 16 12 16ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8C11.4696 8 10.9609 7.78929 10.5858 7.41421C10.2107 7.03914 10 6.53043 10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4Z"
                                            fill="#272727"
                                          />
                                        </svg>
                                        <div
                                          style={{
                                            display: showModal[i]
                                              ? "block"
                                              : "none",
                                          }}
                                          className={style.action_button}
                                          ref={modalRef}
                                        >
                                          <div
                                            className={style.edit}
                                            onClick={() => GetReplace(items)}
                                          >
                                            {" "}
                                            <svg
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M2 14.668H14"
                                                stroke="#212529"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M8.83958 2.4008L3.36624 8.19413C3.15958 8.41413 2.95958 8.84746 2.91958 9.14746L2.67291 11.3075C2.58624 12.0875 3.14624 12.6208 3.91958 12.4875L6.06624 12.1208C6.36624 12.0675 6.78624 11.8475 6.99291 11.6208L12.4662 5.82746C13.4129 4.82746 13.8396 3.68746 12.3662 2.29413C10.8996 0.914129 9.78624 1.4008 8.83958 2.4008Z"
                                                stroke="#212529"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M7.92578 3.36719C8.21245 5.20719 9.70578 6.61385 11.5591 6.80052"
                                                stroke="#212529"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </svg>{" "}
                                            <span>Replace</span>
                                          </div>
                                          <div
                                            className={style.duplicate}
                                            onClick={() => GetDelete(items)}
                                          >
                                            <svg
                                              width="13"
                                              height="16"
                                              viewBox="0 0 13 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M9.00065 0.667969H1.66732C0.933984 0.667969 0.333984 1.26797 0.333984 2.0013V10.668C0.333984 11.0346 0.633984 11.3346 1.00065 11.3346C1.36732 11.3346 1.66732 11.0346 1.66732 10.668V2.66797C1.66732 2.3013 1.96732 2.0013 2.33398 2.0013H9.00065C9.36732 2.0013 9.66732 1.7013 9.66732 1.33464C9.66732 0.967969 9.36732 0.667969 9.00065 0.667969ZM11.6673 3.33464H4.33398C3.60065 3.33464 3.00065 3.93464 3.00065 4.66797V14.0013C3.00065 14.7346 3.60065 15.3346 4.33398 15.3346H11.6673C12.4007 15.3346 13.0007 14.7346 13.0007 14.0013V4.66797C13.0007 3.93464 12.4007 3.33464 11.6673 3.33464ZM11.0007 14.0013H5.00065C4.63398 14.0013 4.33398 13.7013 4.33398 13.3346V5.33464C4.33398 4.96797 4.63398 4.66797 5.00065 4.66797H11.0007C11.3673 4.66797 11.6673 4.96797 11.6673 5.33464V13.3346C11.6673 13.7013 11.3673 14.0013 11.0007 14.0013Z"
                                                fill="#212529"
                                              />
                                            </svg>
                                            <span> Delete</span>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                            )}

                          </tbody>
                        </table>
                      </div>


                      <footer className={style.sectionFooter}>
                        <div className={style.footer_content}>
                          <span style={{ fontWeight: "500" }}>
                            Selected Questions
                          </span>
                          <span>
                            {sectionItem?.questions?.length}{" "}
                            <b style={{ color: "lightgray" }}>
                              /{sectionItem.no_of_questions}
                            </b>
                          </span>
                        </div>

                        <div className={`${style.footer_content_mid} ${style.footer_content_start}`}>
                          {questionResults?.filter((item) => sectionItem?.questions?.map(target => target.id).includes(item.question_id)).map((items, i) => (
                            <span className={style.closeIds}>
                              {items.question_id}
                              {/* <svg
                              style={{ marginLeft: "18px", cursor: "pointer" }}
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.85547 6.34375L17.7151 17.6575"
                                stroke="#272727"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.85324 17.6575L17.7129 6.34375"
                                stroke="#272727"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg> */}
                            </span>
                          ))}
                        </div>

                        <div className={style.footer_content_right}>
                          <span
                            style={{
                              textDecoration: "underline",
                              fontWeight: "500",
                              cursor: "pointer",
                            }}
                            onClick={() => DeleteIdFromList()}
                          >
                            Delete Selected
                          </span>
                          <div
                            className={style.drop_score}
                            onClick={() => OpenMarkingLogic()}
                          >
                            Set Marking Logic &nbsp;
                            <svg
                              width="26"
                              style={{
                                rotate: markingLogicStatus ? "" : "180deg",
                              }}
                              height="24"
                              viewBox="0 0 26 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1445_47115)">
                                <path
                                  d="M5.01822 16.0469L11.7264 9.52687C12.5186 8.75687 13.815 8.75687 14.6072 9.52687L21.3154 16.0469"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1445_47115">
                                  <rect
                                    x="0.820312"
                                    width="24.6927"
                                    height="24"
                                    rx="12"
                                    fill="white"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div
                            className={style.logic}
                            style={{
                              display: markingLogicStatus ? "block" : "none",
                            }}
                          >
                            <div className={style.logics_input}>
                              <div
                                className={style.new}
                                onClick={() => AddNewScore()}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                    stroke="#00ABFB"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.5 12H16.5"
                                    stroke="#00ABFB"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M12 16.5V7.5"
                                    stroke="#00ABFB"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                &nbsp; New Scoring Logic
                              </div>
                              <div className={style.scoring}>
                                {markingLogic?.map((items, i) => (
                                  <div className={style.inputs}>
                                    <input
                                      type="radio"
                                      key={items}
                                      id={i}
                                      name="logic"
                                      onClick={() =>
                                        SelectedMarkingLogic(items)
                                      }
                                    />
                                    <input
                                      onChange={(e) =>
                                        handleCorrectAnswerChange(e, i)
                                      }
                                      type="number"
                                      className={style.inputsNumber}
                                      style={{
                                        display: "inline",
                                        width: "10%",
                                        border: "none",
                                        background: "transparent",
                                      }}
                                      value={items?.correct_answer_marks}
                                    />
                                    <input
                                      onChange={(e) =>
                                        handleInCorrectAnswerChange(e, i)
                                      }
                                      type="number"
                                      style={{
                                        display: "inline",
                                        width: "10%",
                                        border: "none",
                                        background: "transparent",
                                      }}
                                      value={items?.incorrect_answer_marks}
                                    />
                                    {/* <input
                                        onChange={(e) =>
                                          handleUnattemptedChange(e, i)
                                        }
                                        type="number"
                                        style={{
                                          display: "inline",
                                          width: "10%",
                                          border: "none",
                                          background: "transparent",
                                        }}
                                        value={items?.unattempted_penalty}
                                      /> */}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </footer>
                    </div>

                    <div
                      style={{ marginTop: "1rem" }}
                      className={style.performBT}
                    >
                      {/* <button
                        onClick={() => dispatch(changeEdit_test_screen(0))}
                        className={` ${style.btOne} ${style.common}`}
                      >
                        Back
                      </button> */}
                      <button
                        className={` ${style.btTwo} ${style.common}`}
                        onClick={() =>
                          dispatch(Edit_Section_Test(body, testDetails?.id))
                        }
                      >
                        Save And Countinue
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          ))}

        {modal ? (
          <BrowsingQuestionEdit
            SetSelectIds={SetSelectIds}
            selectIds={selectIds}
            selectedIds={body.groups[groupsbutton].sections[sectionbutton]?.questions}
            setModal={setModal}
            totalQuestion={
              body.groups[groupsbutton].sections[sectionbutton].no_of_questions
            }
            AddToTestPaper={AddToTestPaper}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SectionsEdit;
